import React from 'react';

import Distance from '../../styled/Distance';
import InputSearch from '../../styled/InputSearch';
import Box from '../../styled/Box';
import { Body } from '../../styled/ScrollBox/wrappers';
import Text from '../../styled/Text';
import Loader from '../../styled/Loader';
import Toggle from '../../styled/Toggle';
import { Columns } from '../../styled/Columns/wrappers';

import useItemPanel from './useItemPanel';
import { IItemBase, IItemPanelContent, ItemId } from './types';
import ItemPanelItem from './ItemPanelItem';
import FeaturedItems from './FeaturedItems';

export default function ItemPanelContent<TItemId extends ItemId, TItem extends IItemBase<TItemId>>({
  onClose,
  onSelect,
  retainOnClose,
  switchOptions,
  items: allItems,
  featuredItems,
  featuredItemsLabels,
  selectedOnTop,
  selectedId,
  onSearch,
  searchLabel,
  loading,
  renderStatus,
  multipleActions,
  selectableQuery,
  noMatchText,
}: IItemPanelContent<TItemId, TItem>) {
  const {
    query,
    activeSwitch,
    selectStore,
    filteredItems,
    selected,
    handleQueryChange,
    toggleSwitch,
  } = useItemPanel({
    onClose,
    onSelect,
    retainOnClose,
    switchOptions,
    allItems,
    selectedOnTop,
    selectedId,
    onSearch,
  });

  const showFeaturedItems =
    !loading && !query && !activeSwitch && !!selected && featuredItems && featuredItems.length > 1;

  const showNormalSelectedItem = !loading && !!selected && !showFeaturedItems;

  return (
    <>
      {!!onSearch && (
        <InputSearch
          formInput
          onChange={handleQueryChange}
          placeholder={searchLabel}
          title={searchLabel}
          value={query}
        />
      )}
      {!!switchOptions && (
        <>
          <Distance size={'3'} />
          <Columns className="spacebtw-center">
            <Text weight="medium" as="strong">
              {switchOptions.switchLabel}
            </Text>
            <Toggle
              isActive={activeSwitch}
              title={switchOptions.switchLabel}
              onClick={toggleSwitch}
            />
          </Columns>
        </>
      )}

      {(!!onSearch || !!switchOptions) && <Distance size="4" />}

      <Box padding="none">
        <Body className="no-padding">
          {showNormalSelectedItem && (
            <ItemPanelItem
              active={true}
              item={selected}
              onSelect={selectStore}
              renderStatus={renderStatus}
              disableBubbling={multipleActions}
            />
          )}

          {showFeaturedItems && (
            <FeaturedItems
              selectedItem={selected}
              onSelect={selectStore}
              items={featuredItems}
              renderStatus={renderStatus}
              selectableQuery={selectableQuery}
              disableBubbling={multipleActions}
              labels={featuredItemsLabels}
            />
          )}

          {!loading &&
            filteredItems?.map((item) => (
              <React.Fragment key={item.id}>
                {item.id !== selected?.id && (
                  <ItemPanelItem
                    key={item.id}
                    active={item.id === selectedId}
                    item={item}
                    onSelect={selectStore}
                    renderStatus={renderStatus}
                    disableBubbling={multipleActions}
                    selectable={selectableQuery ? selectableQuery(item) : true}
                  />
                )}
              </React.Fragment>
            ))}
          {!filteredItems?.length && !loading && (
            <>
              <Distance size="2" />
              <Text align="center">
                {noMatchText || 'Vi kunde tyvärr inte matcha något med din sökfråga.'}
              </Text>
            </>
          )}
        </Body>
      </Box>

      {loading && <Loader />}
    </>
  );
}
